import React, { useEffect } from 'react';
import { useFormControls } from '@features/onboarding/hooks/useFormControls';

import { Select } from '@components/shared/select/Select';

import { cn } from '@utils/index';
export const OnboardingHeader = () => {
  const { currentFormStep, formSteps, handleJumpTo } = useFormControls();

  const items = formSteps.map((item) => ({
    value: item.sectionName,
    label: item.sectionName,
  }));

  useEffect(() => {
  }, [])

  // TODO пока нужен чтобы видеть визуально каждый этам не заполняя
  return null;
  return (
    <div className={cn('flex w-full fixed top-0 right-0 z-50')}>
      <p className="text-success text-[clamp(14px,1.5vw,18px)] font-light sm:self-center self-end">
        TEMP HELPER:{' '}
      </p>

      <div className="flex sm:flex-row flex-col sm:items-center sm:gap-6 gap-1.5">
        <span className="text-success sm:text-base text-sm font-semibold @sm:block hidden">
          Jump to:
        </span>

        <Select
          className="sm:w-[clamp(200px,25vw,400px)] !h-9 md:!h-11.5 w-full"
          items={items}
          value={currentFormStep?.sectionName}
          onValueChange={handleJumpTo}
          placeholder="Choose Section"
        />
      </div>
    </div>
  );
};
